<template>
    <div>
        <card-header title="Session Groups" icon="fa-layer-group"></card-header>

        <card-toolbar>
            <button @click="$openCard('conf-new-group', {confId: props.confId}, card)"><i class="far fa-plus"></i>New Session Group</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <conf-group-tile
                    :card="card"
                    :group="group"
                    v-for="group in groups"
                    :active="(child && child.definition.component === 'conf-edit-group' && group.id === parseInt(child.props.groupId))"
                    @click="$openCard('conf-edit-group', {confId: group.conference_id, groupId: group.id}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";

    import {client as http} from '@/http_client';
    import CardToolbar from "../../../../TIER/components/CardToolbar";
    import ConfSessionTile from "../../../../components/tiles/ConfSessionTile";
    import ConfGroupTile from "../../../../components/tiles/ConfGroupTile";

    export default {
        components: {ConfGroupTile, ConfSessionTile, CardToolbar, CardList, CardHeader, CardBody},
        props: ['card', 'props', 'child'],
        data() {
            return {
                groups: {}
            };
        },
        methods: {
            loadGroups: function(force) {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId + '/groups', {force}).then(response => {
                    this.groups = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            reload: function() {
                this.loadGroups(true);
            }
        },
        mounted() {
            this.loadGroups();
        }
    };
</script>

<style>

</style>
